import { render, staticRenderFns } from "./ValidityInformation.vue?vue&type=template&id=f4b9bb40&scoped=true"
import script from "./ValidityInformation.vue?vue&type=script&lang=js"
export * from "./ValidityInformation.vue?vue&type=script&lang=js"
import style0 from "./ValidityInformation.vue?vue&type=style&index=0&id=f4b9bb40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b9bb40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4b9bb40')) {
      api.createRecord('f4b9bb40', component.options)
    } else {
      api.reload('f4b9bb40', component.options)
    }
    module.hot.accept("./ValidityInformation.vue?vue&type=template&id=f4b9bb40&scoped=true", function () {
      api.rerender('f4b9bb40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/management/amendment/ValidityInformation.vue"
export default component.exports